export default __webpack_public_path__ + "static/media/LOGO12.38627c02.png";